import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { inject, observer } from 'mobx-react';
import { withRouter } from 'react-router-dom';
import { TopLevelContainer } from '@xo-union/tk-component-grid';
import { Snackbar } from '@xo-union/tk-component-alerts';
import { compose } from '@xo-union/react-css-modules';
import Loader from '~/glm/components/shared/loader';
import AddressCollectionPageHeader from '~/glm/components/address-collection/address-collection-page-header';
import FullPageModalHeader from '~/glm/components/shared/layout/full-page-modal-header';
import FullScreenModal from '~/glm/containers/full-screen-modal';
import GdsUiState from '~/glm/models/gds/gds-ui-state';
import RsvpSettingsModal from '~/glm/components/guest-list/modals/rsvp-settings-modal';
import MessageGuestModal from '~/glm/components/guest-list/modals/message-guest-modal';
import ExportGuestListModal from '~/glm/components/export-guest-list/export-modal';
import styles from './address-collection-page.scss';

@withRouter
@inject('initGuestListPromise', 'gdsUiState')
@observer
class AddressCollectionPage extends Component {
  static propTypes = {
    initGuestListPromise: PropTypes.instanceOf(Promise).isRequired,
    gdsUiState: PropTypes.instanceOf(GdsUiState).isRequired,
  };

  constructor(props, context) {
    super(props, context);
    this.state = { isReady: false };

    this.props.initGuestListPromise.then(() => {
      this.setState({ isReady: true });
    });
    this.props.gdsUiState.setSnackbarRef(React.createRef());
  }

  onClose = () => {
    const { gdsUiState, history } = this.props;

    gdsUiState.setAddressCollectionView(false);
    history.push('/our-guest-list');
  };

  render() {
    if (!this.state.isReady) {
      return <Loader />;
    }
    const { gdsUiState } = this.props;

    return (
      <FullScreenModal>
        <>
          <FullPageModalHeader title="Request Guest Info" onClose={this.onClose} />
          <TopLevelContainer>
            <div className={styles.addressCollectionPage}>
              <div className={styles.mainContent}>
                <AddressCollectionPageHeader />
                <div className={styles.imageContainer}>
                  <img
                    className={styles.image}
                    src={'https://media-api.xogrp.com/images/9223c785-7111-41a8-9980-5456877166c6?compress=true'}
                    alt="Request Guest Info Form"
                  />
                </div>
              </div>
            </div>

            <Snackbar
              id="address-collection-snackbar"
              ref={gdsUiState.snackbarRef}
              classes={compose({ container: styles.snackBarContainer })}
            />
            {gdsUiState.rsvpModalView ? <RsvpSettingsModal /> : null}
            {gdsUiState.exportGuestModalView ? <ExportGuestListModal /> : null}
            {gdsUiState.messageGuestModalView ? <MessageGuestModal /> : null}
          </TopLevelContainer>
        </>
      </FullScreenModal>
    );
  }
}

export default AddressCollectionPage;
